import { warningAlert } from 'utils/alert';
import { t } from 'utils/getTranslations';

export const MAX_SEARCH_KEYWORDS = 6;

export const splitSearchKeywords = (text: string): string[] =>
    text.trim().split(/\s+/).filter(Boolean).slice(0, MAX_SEARCH_KEYWORDS);

export const wasKeywordsTruncated = (text: string): boolean =>
    text.trim().split(/\s+/).filter(Boolean).length > MAX_SEARCH_KEYWORDS;

export const warnIfKeywordsTruncated = (searchText: string) => {
    if (wasKeywordsTruncated(searchText)) {
        warningAlert(t('search-keywords-truncated'));
    }
};
